<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <!-- <router-view /> -->
      <!-- <keep-alive include="Home" v-if="is">
        <router-view></router-view>
      </keep-alive> -->
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      is: true
    }
  },
  components: {
  },
  watch: {
    // '$route.path' (newVal, oldVal) {
    //   console.log(newVal + '---' + oldVal)
    //   if (oldVal == '/login') {
    //     this.is = false
    //   } else {
    //     this.is = true
    //   }
    // }
    '$route.path' () {
      console.log(this.$route.path)
    //   if (this.$route.path != '/login') {
    //     document.title = '聪聆科技'
    //   }
    }
  }
}
</script>

<style lang="scss">
@import "./assets/css/common2.scss";
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue